// Convert kebab-case to camelCase: my-page-asset > myPageAsset
export const camelize = s => s.replace(/-(.)/g, l => l[1].toUpperCase());
export const capitalizeWord = s => `${s.charAt(0).toUpperCase()}${s.substr(1)}`;
